import React from 'react';

import { useSelector } from 'react-redux';

import { selectCloudRecordingStatus } from '../../../../features/cloud-recording';
import { StopCloudRecordingButton } from './stop-cloud-recording-button';
import { WaitingCloudRecordingButton } from './waiting-cloud-recording-button';

export function CloudRecordingButton() {
    const cloudRecordingStatus = useSelector(selectCloudRecordingStatus);

    if (cloudRecordingStatus === 'STARTING') {
        return <WaitingCloudRecordingButton />;
    }

    return <StopCloudRecordingButton />;
}
